<div *ngIf="!loader">
    <div class="heading_sert">
       <sm-title-bar pageTitle="Configure discount" [backWithParams]="true"></sm-title-bar>
    </div>
    <div class="row">
       <div class="col-sm-8">
          <div class="lsk_cardf">
            <div class="row">
                <div class="col-sm-12">
             <div class="radio_group">
                <label style="margin-bottom: 14px; font-size: 15px;
                font-weight: normal;
                color: #3f3f3f;">Discount type </label> <br/>
                <mat-radio-group [(ngModel)]="discountObj.discountType">
                   <mat-radio-button [value]="2">Whole Amount</mat-radio-button>
                   <mat-radio-button [value]="1">Percentage</mat-radio-button>
                </mat-radio-group>
             </div>
            </div>
            <div class="col-sm-12">
             <div class="form-group">
                <label for="Description" style="margin-bottom: 14px; font-size: 15px;
                font-weight: normal;
                color: #3f3f3f;">Discount available on</label> <br/>
                <div class="add_crt" style="display: flex; gap: 20px;">
                   <div class="try" *ngIf="shop_status != '2'">
                      <mat-checkbox [value]="discountObj.shop_service_status" (change)="selectCheck($event,1)" [checked]="discountObj.shop_service_status == 1"></mat-checkbox>
                      <label for="testing1" class="check-label">Shop service</label>
                   </div>
                   <div class=" try" *ngIf="home_status != '2'">
                     <mat-checkbox [value]="discountObj.home_service_status" (change)="selectCheck($event,0)" [checked]="discountObj.home_service_status == 1"></mat-checkbox>
   
      
                       <label for="testing1" class="check-label">Home service</label>
                   </div>
                   <div class=" try" *ngIf="virtual_status != '2'">
                     <mat-checkbox [value]="discountObj.virtual_service_status" (change)="selectCheck($event,2)" [checked]="discountObj.virtual_service_status == 1"></mat-checkbox>
   
      
                       <label for="testing1" class="check-label">Virtual service</label>
                   </div>
                </div>
             </div>
            </div>
            </div>

             <div >
               <mat-form-field appearance="outline">
                  <mat-label *ngIf="discountObj.discountType == 2">Enter discount value</mat-label>
                <mat-label *ngIf="discountObj.discountType == 1">Enter discount in percentage (%)</mat-label>
                <input smDecimalOnly type="number" matInput [(ngModel)]="discountObj.discountAmount "/>
                <!--  -->
              </mat-form-field>
             </div>
             <div >
               <mat-form-field appearance="outline">
                  <mat-label>Enter minimum bill amount</mat-label>
                  <input smDecimalOnly type="number" matInput [(ngModel)]="discountObj.minBillAmount "/>
                  <!--  -->
                </mat-form-field>
             </div>
             <div *ngIf="discountObj.discountType == 1">
               <mat-form-field appearance="outline">
                 <mat-label>Enter maximum discount amount</mat-label>
                 <input smDecimalOnly type="number" matInput [(ngModel)]="discountObj.maxDiscount "/>
                 <!--  -->
               </mat-form-field>
             </div>
             <div class="row">
                <div class="col-sm-6">
             
                  <mat-form-field class="date" appearance="outline">
                     <mat-label>Start date</mat-label>
                     <input matInput [matDatepicker]="picker1" [(ngModel)]="discountObj.start_date ">
                     <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                     <mat-datepicker #picker1></mat-datepicker>
                   </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="date" appearance="outline">
                     <mat-label>End date</mat-label>
                     <input matInput [matDatepicker]="picker2" [(ngModel)]="discountObj.end_date ">
                     <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                     <mat-datepicker #picker2></mat-datepicker>
                   </mat-form-field>
            </div>
             </div>
             <div class="item_list add_padding" >
                <div class="item_list_data add_margin_bottom">
                   <span>Enable Other Discount</span>
                   <mat-slide-toggle [checked]="discountObj.otherDiscounts == 1" (change)="onToggleChangeOtherDiscount($event)"></mat-slide-toggle>
                </div>
             </div>
             <div class="cabh_sect">
                <!-- <button  mat-flat-button color="accent" class="resat-btn" >Cancel</button> -->
                <button mat-flat-button color="accent" class="submit-btn"  (click)="onSubmitDiscountDetails()"
                [disabled]="
                !discountObj.discountAmount ||
                !discountObj.minBillAmount ||
                !discountObj.start_date ||
                !discountObj.end_date 
                
                ">Save</button>
             </div>
          </div>
       </div>
       <div class="col-md-4 booking-sidebar">
          <div class="faq">
             <mat-accordion>
                <mat-expansion-panel [expanded]="panelState[0]" (opened)="panelState[0] = true" (closed)="panelState[0] = false">
                <mat-expansion-panel-header>
                   <mat-panel-title>
                     What is 'Whole amount' and 'Percentage' type?
                   </mat-panel-title>
                </mat-expansion-panel-header>
                <p>When you are giving a lump-sum discount in your bill as a fixed value, you need to go with 'Whole amount' type. Otherwise if you are giving discount in your bill/invoice in a percentage(%) of the total bill value, you have to set the the discount type to 'Percentage'.
                </p>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelState[1] = true"
                (closed)="panelState[1] = false">
                <mat-expansion-panel-header>
                   <mat-panel-title>
                     What is 'Maximum discount amount' in 'Percentage' type?
                   </mat-panel-title>
                </mat-expansion-panel-header>
                <p>You need to set a threshold value for the maximum discount one customer can get on the bill amount. A large bill can also produce large discount amount too. This field is to prevent that.
                </p>
                </mat-expansion-panel>
                <mat-expansion-panel (opened)="panelState[2] = true"
                (closed)="panelState[2] = false">
                <mat-expansion-panel-header>
                   <mat-panel-title>
                     What is 'Enable other discount'?
                   </mat-panel-title>
                </mat-expansion-panel-header>
                <p>Apart from the 'Bill discount', a customer can also get discount on individual services and applying coupons. You can control whether they would be awarded with all these discounts together or only the 'Bill discount'.  
                </p>
                </mat-expansion-panel>
             
             </mat-accordion>
          </div>
       </div>
    </div>
 </div>